import $ from "jquery";

const Modal = () => {
	function init() {
		handleToggleModal();
	}

	function handleToggleModal() {
		$(document).on("click", ".js-modal-btn", function () {
			let $e = $(this);
			let $openModal = $($e.data("modal"));
			$openModal.toggleClass("modal--is-shown");
		});
	}

	init();
};

export default Modal;
